// src/config/proxy.js

export const PROXY_SERVERS = [
  {
    id: 'proxy-1',
    name: 'ProtocolGOIDA Proxy',
    protocol: 'MTProto',
    port: 26503,
    link: 'tg:/proxy?server=proxy.protocolgoida.net&port=26503&secret=ee704e0a3e86be3de2287ede4fa92accb77275312e6e657473746162696c6974792e7275',
  }
];
